import { cva } from "class-variance-authority";

export const chipVariants = cva(
  "inline-flex items-center gap-1 transition-colors focus-visible:outline-none focus-visible:ring-gray-1000 focus-visible:ring-1 focus-visible:ring-offset-1",
  {
    variants: {
      variant: {
        fill: "",
        outline: "",
      },
      size: {
        xs: "text-label3 h-4",
        sm: "text-label3 h-6",
        md: "text-label2 h-8",
      },
      radius: {
        square: "rounded-4",
        round: "rounded-[999px]",
      },
      color: {
        default: "",
        primary: "",
        error: "",
        warn: "",
        info: "",
        success: "",
      },
      disabled: {
        true: "text-gray-400 bg-gray-100 pointer-events-none",
        false: "",
      },
      mode: {
        default: "",
        select: "",
        click: "",
      },
      hasPrefixIcon: {
        true: "pl-1",
        false: "pl-[6px]",
      },
      hasSuffixIcon: {
        true: "pr-1",
        false: "pr-[6px]",
      },
    },
    compoundVariants: [
      {
        variant: "outline",
        color: "default",
        disabled: false,
        class: "text-gray-1000 border border-gray-500 bg-white",
      },
      {
        variant: "outline",
        color: "primary",
        disabled: false,
        mode: ["default", "click"],
        class: "border border-primary-500",
      },
      {
        variant: "outline",
        color: "error",
        disabled: false,
        mode: ["default", "click"],
        class: "border border-red-500",
      },
      {
        variant: "outline",
        color: "warn",
        disabled: false,
        mode: ["default", "click"],
        class: "border border-orange-500",
      },
      {
        variant: "outline",
        color: "info",
        disabled: false,
        mode: ["default", "click"],
        class: "border border-blue-500",
      },
      {
        variant: "outline",
        color: "success",
        disabled: false,
        mode: ["default", "click"],
        class: "border border-green-700",
      },

      {
        variant: "outline",
        color: "primary",
        disabled: false,
        mode: "select",
        class:
          "text-gray-1000 border border-gray-500 bg-white [&:is([data-state='checked'])]:border [&:is([data-state='checked'])]:border-primary-500",
      },
      {
        variant: "outline",
        color: "error",
        disabled: false,
        mode: "select",
        class:
          "text-gray-1000 border border-gray-500 bg-white [&:is([data-state='checked'])]:border [&:is([data-state='checked'])]:border-red-500",
      },
      {
        variant: "outline",
        color: "warn",
        disabled: false,
        mode: "select",
        class:
          "text-gray-1000 border border-gray-500 bg-white [&:is([data-state='checked'])]:border [&:is([data-state='checked'])]:border-orange-500",
      },
      {
        variant: "outline",
        color: "info",
        disabled: false,
        mode: "select",
        class:
          "text-gray-1000 border border-gray-500 bg-white [&:is([data-state='checked'])]:border [&:is([data-state='checked'])]:border-blue-500",
      },
      {
        variant: "outline",
        color: "success",
        disabled: false,
        mode: "select",
        class:
          "text-gray-1000 border border-gray-500 bg-white [&:is([data-state='checked'])]:border [&:is([data-state='checked'])]:border-green-700",
      },

      {
        variant: "fill",
        color: "default",
        disabled: false,
        class: "bg-gray-100 text-gray-1000",
      },
      {
        color: "primary",
        mode: ["default", "click"],
        disabled: false,
        class: "bg-primary-10 text-primary-500",
      },
      {
        color: "error",
        mode: ["default", "click"],
        disabled: false,
        class: "bg-red-10 text-red-500",
      },
      {
        color: "warn",
        mode: ["default", "click"],
        disabled: false,
        class: "bg-orange-10 text-orange-500",
      },
      {
        color: "info",
        mode: ["default", "click"],
        disabled: false,
        class: "bg-blue-10 text-blue-500",
      },
      {
        color: "success",
        mode: ["default", "click"],
        disabled: false,
        class: "bg-green-10 text-green-700",
      },

      {
        color: "primary",
        mode: "select",
        disabled: false,
        class:
          "bg-gray-100 text-gray-1000 [&:is([data-state='checked'])]:bg-primary-10 [&:is([data-state='checked'])]:text-primary-500",
      },
      {
        color: "error",
        mode: "select",
        disabled: false,
        class:
          "bg-gray-100 text-gray-1000 [&:is([data-state='checked'])]:bg-red-10 [&:is([data-state='checked'])]:text-red-500",
      },
      {
        color: "warn",
        mode: "select",
        disabled: false,
        class:
          "bg-gray-100 text-gray-1000 [&:is([data-state='checked'])]:bg-orange-10 [&:is([data-state='checked'])]:text-orange-500",
      },
      {
        color: "info",
        mode: "select",
        disabled: false,
        class:
          "bg-gray-100 text-gray-1000 [&:is([data-state='checked'])]:bg-blue-10 [&:is([data-state='checked'])]:text-blue-500",
      },
      {
        color: "success",
        mode: "select",
        disabled: false,
        class:
          "bg-gray-100 text-gray-1000 [&:is([data-state='checked'])]:bg-green-10 [&:is([data-state='checked'])]:text-green-700",
      },

      {
        disabled: false,
        mode: ["select", "click"],
        class: "cursor-pointer",
      },
      {
        disabled: true,
        variant: "outline",
        class: "border border-gray-200",
      },
    ],
    defaultVariants: {
      variant: "fill",
      size: "sm",
      radius: "round",
      color: "default",
      mode: "default",
      disabled: false,
      hasPrefixIcon: false,
      hasSuffixIcon: false,
    },
  },
);
